export interface TranslatedString {
    [key: string]: string
}

export interface Image {
    src: string
    alt: string
    url?: string
}

export interface ImageWithTranslatedAlt {
    src: string
    alt: TranslatedString
    url?: string
}

export enum LanguageCode {
    ENGLISH = 'en',
    SPANISH = 'es',
    MANDARIN = 'zh',
    TAGALOG = 'tl',
    VIETNAMESE = 'vi',
    ARABIC = 'ar',
    FRENCH = 'fr',
    KOREAN = 'ko',
    RUSSIAN = 'ru',
    GERMAN = 'de',
    HAITIAN_CREOLE = 'ht',
    PORTUGUESE = 'pt',
    JAPANESE = 'ja',
    POLISH = 'pl',
}

export enum ErrorMessage {
    NO_INTERNET = 'No Internet Connection',
    INVALID_JWT = 'Invalid JWT',
    NO_JWT = 'Not Logged In',
    ISA_REQUEST_FAILED = 'ISA Request Failed',
    CMS_REQUEST_FAILED = 'CMS Request Failed',
    DB_REQUEST_FAILED = 'DB Request Failed',
    ASYNC_STORAGE_REQUEST_FAILED = 'AsyncStorage Request Failed',
    INVALID_USER_ID = 'Invalid user ID given, or user ID missing',
    MISSING_USER_OBJ = 'Locally stored user information is missing',
    OTHER_ERROR = 'Other error; see console logs',
    FS_REQUEST_FAILED = 'FileSystem Request Failed',
    HAZARD_NOT_EXIST = 'The hazard does not exist',
    REQUEST_TIMEOUT = 'The request timed out',
    LANG_NOT_SAVED = 'The selected language has not been saved for offline use.',
    UNIQUE_ERROR = 'This entity already exists in the DB',
    HAZARD_RETRIEVAL_ERROR = 'Unable to retrieve hazards from server',
    NO_PROFILE_PICTURE = 'No profile picture found',
}

export const termsAndConditionsURL: string =
    'https://app.termly.io/document/terms-of-use-for-website/d251437c-432f-451a-af09-4ff32d82d21a'

export const privacyPolicyURL: string =
    'https://app.termly.io/document/privacy-policy/0e3a8766-b405-48c5-a910-518c230c3c12'

export const privacyAndSecurityURL: string =
    'https://www.hazadapt.com/privacy-and-security'

export const hazardRequestURL: string = 'https://hazadapt.com/request-a-hazard'

export const reportABugURL: string = 'https://hazadapt.com/report-a-bug'

export const reportTranslationErrorURL: string =
    'https://hazadapt.com/report-translation-error'

export const submitFeedbackURL: string = 'https://hazadapt.com/feedback'

export const whyHazAdaptURL: string = 'https://www.hazadapt.com/why-hazadapt'

export const twitterURL: string = 'https://twitter.com/hazadapt'
export const facebookURL: string = 'https://facebook.com/HazAdapt'
export const instagramURL: string = 'https://instagram.com/hazadapt'
export const linkedinURL: string = 'https://linkedin.com/company/hazadapt/'
export const websiteURL: string = 'https://hazadapt.com'
export const hazAdaptOnAppStoreURL: string =
    'https://apps.apple.com/us/app/hazadapt/id1548019714'

export const hazAdaptOnGooglePlayURL: string =
    'https://play.google.com/store/apps/details?id=com.hazadapt.hazadapt'

export const prepChecksLearnMoreURL: string =
    'https://www.hazadapt.com/product/about-prep-checks'

export enum PrepCheckScope {
    INDIVIDUAL = 'Individual',
    FAMILY_OR_HOUSEHOLD = 'Family_Or_Household',
    WORK = 'Work',
}

export enum PrepCheckStatus {
    DRAFT = 'draft',
    SUBMITTED = 'submitted',
}

export enum PrepCheckComponentRating {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
}

export enum PreparednessLevel {
    NOVICE = 'Novice',
    INTERMEDIATE = 'Intermediate',
    ADVANCED = 'Advanced',
}

export const PrepCheckComponentRatingThreshold: Map<
    PrepCheckComponentRating,
    number
> = new Map<PrepCheckComponentRating, number>([
    [PrepCheckComponentRating.LOW, 0],
    [PrepCheckComponentRating.MEDIUM, 0.36],
    [PrepCheckComponentRating.HIGH, 0.75],
])

export const PreparednessLevelThreshold: Map<PreparednessLevel, number> =
    new Map<PreparednessLevel, number>([
        [PreparednessLevel.NOVICE, 0],
        [PreparednessLevel.INTERMEDIATE, 0.36],
        [PreparednessLevel.ADVANCED, 0.75],
    ])

export interface PickerItem<T> {
    label: string
    value: T
}
